module.exports = __webpack_public_path__ + "img/publications.268076cc.svg";